import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { TeamSummaryService } from '../../user/team-summary.service';
import { EquipmentSummaryService } from '../../equipment';

import { EcallDetailService } from '../ecall-detail';
import { EcallEditService } from './ecall-edit.service';
import { EcallEquipmentSummaryService } from '../ecall-detail';
import { Ecall, IsActive, EcallStatus } from './../../../../model';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-ecall-edit',
  templateUrl: './ecall-edit.component.html',
  styleUrls: ['./ecall-edit.component.css']
})
export class EcallEditComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  ecallId = '';
  model = new Ecall(0, '', '', '', '', '', [], 99, '', [], [], '', '', '', '', '', '', '');
  ecallStatus = EcallStatus;

  redirect = true;

  siteId: any;
  // receivedTimeFormatted;
  // arrivedTimeFormatted;
  // completedTimeFormatted;

  teams: any[];
  teamsOptions = [];
  dropdownSettings = {};
  selectedTeams: Array<any> = [];
  checkedTeamNames: Array<String> = [];
  checkedTeamNums: Array<number> = [];

  technicians: any[];
  techniciansOptions = [];
  dropdownSettingsTechnician = {};
  selectedTechnicians: Array<any> = [];
  checkedTechnicianNames: Array<String> = [];
  checkedTechnicianNums: Array<number> = [];
  originalTechnicianModel: Array<any> = [];
  technicianListModel: Array<any> = [];

  contactPersonLengthError: Boolean = false;
  contactNumberLengthError: Boolean = false;
  remarksLengthError: Boolean = false;
  customerReportLengthError: Boolean = false;

  originalEquipmentModel: Array<any> = [];
  originalEquipments: any[];
  dataTable: any;

  // currentStep = 0 (ecall static info)
  //             = 1 (add equipment)
  //             = 2 (review)
  currentStep: number;
  // indicate number of times the user go next / go back to different steps
  loadStepCounter: number;
  ecallEditStep: number;
  ecall = new Ecall();
  selectedEquipmentList: string[];
  selectedEquipments: string[];  // hand to API

  equipmentList: any[];
  selectedIds: number[];
  equipmentCheckboxes = {};
  equipmentJobNumber = {};

  editEcallInputs: any;
  equipmentDetailListModel: Array<any> = [];

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private teamSummaryService: TeamSummaryService,
    private equipmentSummaryService: EquipmentSummaryService,
    private ecallDetailService: EcallDetailService,
    private ecallEditService: EcallEditService,
    private ecallEquipmentSummaryService: EcallEquipmentSummaryService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.currentStep = 0;
    this.loadStepCounter = 0;
    this.route.params.subscribe(params => {
      this.ecallId = params['id'];
    });
  }

  ngOnInit() {

    this.ecallStatus = EcallStatus;

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Team',
      enableCheckAll: false,
      enableSearchFilter: true
    };

    this.dropdownSettingsTechnician = {
      singleSelection: false,
      text: 'Select Technician',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      enableSearchFilter: true
    };

    this.contactNumberLengthError = false;
    this.contactPersonLengthError = false;
    this.remarksLengthError = false;

    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];

    this.selectedIds = [];

    this.getTeamSummary();
    this.getDetail();
    this.getOriginalEquipmentDetail();
  }

  getTeamSummary() {
    this.teamSummaryService.getSummary()
      .subscribe((data: any) => {
        this.teams = data;
        const options = [];
        for (const team of this.teams) {
          let option: any;
          option = { 'itemName': team.name, 'id': team.id };
          options.push(option);
        }

        this.teamsOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  getTeamMemberSummary() {
    this.teamSummaryService.getTechnicianSummary(this.checkedTeamNums)
      .subscribe((data: any) => {
        this.technicians = data;
        const options = [];
        for (const tech of this.technicians) {
          let option: any;
          option = { 'itemName': tech.title, 'id': tech.id };
          options.push(option);
        }

        this.techniciansOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  onTeamSelect(item: any) {
    this.pushTeamsArray();
    this.getTeamMemberSummary();
  }

  onTeamDeselect(item: any) {
    this.pushTeamsArray();
    // clear technicians input
    this.selectedTechnicians = [];
    if (this.checkedTeamNums.length == 0) {
      // if no team is selected, clear technicians options
      this.techniciansOptions = [];
    } else {
      // else re-get technician list
      this.getTeamMemberSummary();
    }
  }

  getDetail() {
    this.ecallDetailService
      .getDetail(this.ecallId)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            // set default checked teams
            if (this.model.teamListModel) {
              for (const team of this.model.teamListModel) {
                this.selectedTeams.push({ 'id': team.id, 'itemName': team.name });
                this.checkedTeamNums.push(team.id);
              }
            }
            // get user summary of those checked teams
            this.getTeamMemberSummary();

            interface TechnicianModel {
              userId: number;
              isActive: number;
            }
            // set default checked technicians
            if (this.model.userArrayModels) {
              for (const user of this.model.userArrayModels) {
                this.selectedTechnicians.push({ 'id': user.id, 'itemName': user.title });
                // put the original technicians into originalTechnicianModel where they all have isActive: 0 (removed)
                const tempModel: TechnicianModel = { userId: user.id, isActive: 0 };
                this.originalTechnicianModel.push(tempModel);
              }
            }

            this.siteId = this.model.siteId;
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  getOriginalEquipmentDetail() {
    this.ecallEquipmentSummaryService
      .getSummary(this.ecallId)
      .subscribe(
        (data: any) => {
          this.originalEquipments = data.equipmentListModel;

          interface EquipmentDetailModel {
            equipmentId: number;
            jobNumber: string;
            isActive: number;
          }
          // put the original equipment into originalEquipmentModel where they all have isActive: 0 (removed)
          for (const equipment of this.originalEquipments) {
            const tempModel: EquipmentDetailModel = { equipmentId: equipment.equipmentId, jobNumber: equipment.jobNumber, isActive: 0 };
            this.originalEquipmentModel.push(tempModel);
          }

          this.chRef.detectChanges();
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  goToAddEquipment(ecallEditForm): void {
    this.getInput(ecallEditForm);
    if (this.loadStepCounter === 0) {
      this.getEquipmentSummaryForInitialization();
    } else {
      this.getEquipmentSummary();
    }
    this.currentStep++;
    this.loadStepCounter++;
  }

  public getInput(ecallEditForm): any {
    this.ecall.id = Number(this.ecallId);
    this.ecall.location = this.model.location;
    this.ecall.customerShortName = this.model.customerShortName;
    this.ecall.customer = this.model.customer;
    this.ecall.contactPerson = ecallEditForm.controls.contactPerson.value;
    this.ecall.contactNumber = ecallEditForm.controls.contactNumber.value;
    this.ecall.status = this.model.status;  // uneditable
    this.ecall.creationTime = this.model.creationTime;  // uneditable
    this.ecall.receivedTime = this.model.receivedTime;  // uneditable
    this.ecall.arrivedTime = this.model.arrivedTime;  // uneditable
    this.ecall.completedTime = this.model.completedTime;  // uneditable
    this.ecall.siteId = this.siteId;
    this.pushTeamsArray();
    this.ecall.teamIds = this.checkedTeamNums;
    this.pushTechniciansArray();
    this.ecall.remarks = ecallEditForm.controls.remarks.value;
    this.ecall.customerReport = this.model.customerReport;
  }

  pushTeamsArray(): void {
    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    for (const team of this.selectedTeams) {
      this.checkedTeamNames.push(team.itemName);
      this.checkedTeamNums.push(team.id);
    }
  }

  pushTechniciansArray(): void {
    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];
    for (const technician of this.selectedTechnicians) {
      this.checkedTechnicianNames.push(technician.itemName);
      this.checkedTechnicianNums.push(technician.id);
    }
  }

  checkLength(ele: any) {
    if (ele.srcElement.id === 'contactPerson') {
      if (ele.srcElement.value.length > 100) {
        this.contactPersonLengthError = true;
      } else {
        this.contactPersonLengthError = false;
      }
    }

    if (ele.srcElement.id === 'contactNumber') {
      if (ele.srcElement.value.length > 100) {
        this.contactNumberLengthError = true;
      } else {
        this.contactNumberLengthError = false;
      }
    }

    if (ele.srcElement.id === 'remarks') {
      if (ele.srcElement.value.length > 1000) {
        this.remarksLengthError = true;
      } else {
        this.remarksLengthError = false;
      }
    }

    if (ele.srcElement.id === 'customerReport') {
      if (ele.srcElement.value.length > 1000) {
        this.customerReportLengthError = true;
      } else {
        this.customerReportLengthError = false;
      }
    }
  }

  getEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#ecallEquipmentDataTables')) {
          $('#ecallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#ecallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  // this is only for loading add equipment page for the first time
  getEquipmentSummaryForInitialization(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#ecallEquipmentDataTables')) {
          $('#ecallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;

        // first clear selectedIds
        this.selectedIds = [];

        // initialize equipmentCheckboxes & equipmentJobNumber
        for (const equip of this.equipmentList) {
          // first set this checkboxes to be unchecked
          this.equipmentCheckboxes[equip.equipmentId] = false;
          // first set this jobNumbers to be default value (jobNumbers[0])
          if (equip.jobNumbers) {
            this.equipmentJobNumber[equip.equipmentId] = equip.jobNumbers[0];
          }

          // check the checkboxes & choose the right jobNumber according to the original equipment list
          for (const originalEquip of this.originalEquipments) {
            if (equip.equipmentId === originalEquip.equipmentId) {
              // push it into selectedIds
              this.selectedIds.push(equip.equipmentId);
              this.equipmentCheckboxes[equip.equipmentId] = true;
              if (originalEquip.jobNumber) {  // if jobNumber is null then dun use it
                this.equipmentJobNumber[equip.equipmentId] = originalEquip.jobNumber;
              }
            }
          }
        }

        this.chRef.detectChanges();

        const table: any = $('#ecallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  goBack(): void {
    this.currentStep--;
    if (this.currentStep === 1) {
      this.getEquipmentSummary();
    }
    this.loadStepCounter++;
  }

  selectEquipment(event): void {
    if (event.srcElement.checked === true) {  // checkbox checked
      this.selectedIds.push(Number(event.srcElement.id));
    } else if (event.srcElement.checked === false) {  // checkbox unchecked
      const removeIndex: number = this.selectedIds.indexOf(Number(event.srcElement.id));
      if (removeIndex !== -1) {
        this.selectedIds.splice(removeIndex, 1);
      }
    }
  }

  onJobNumberSelect(item: any) {
    this.equipmentJobNumber[item.srcElement.id] = item.srcElement.value;
  }

  getSelectedEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummaryByIds(this.selectedIds)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#selectedEquipmentDataTables')) {
          $('#selectedEquipmentDataTables').DataTable().destroy();
        }

        this.selectedEquipmentList = data.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#selectedEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  goToReview() {
    this.currentStep++;
    this.getSelectedEquipmentSummary();

    interface EquipmentDetailModel {
      equipmentId: number;
      jobNumber: string;
      isActive: number;
    }
    // clear equipmentModel
    this.equipmentDetailListModel = [];
    // remove all origianl equipment (by pushing the isActive: 0 elements)
    for (const original of this.originalEquipmentModel) {
      this.equipmentDetailListModel.push(original);
    }
    for (const equipmentId of this.selectedIds) {
      // create an equipmentDetailModel for this selected equipment
      const tempModel: EquipmentDetailModel = { equipmentId: equipmentId, jobNumber: this.equipmentJobNumber[equipmentId], isActive: 1 };
      this.equipmentDetailListModel.push(tempModel);
    }

    interface TechnicianModel {
      userId: number;
      isActive: number;
    }
    // clear technicianListModel
    this.technicianListModel = [];
    // remove all origianl technician (by pushing the isActive: 0 elements)
    for (const originalTech of this.originalTechnicianModel) {
      this.technicianListModel.push(originalTech);
    }
    for (const technicianNum of this.checkedTechnicianNums) {
      // create an equipmentDetailModel for this selected equipment
      const tempModel: TechnicianModel = { userId: technicianNum, isActive: 1 };
      this.technicianListModel.push(tempModel);
    }

    this.editForm();
    this.loadStepCounter++;
  }

  editForm() {
    this.editEcallInputs = {
      creationTime: this.ecall.creationTime,
      receivedTime: this.ecall.receivedTime,
      arrivedTime: this.ecall.arrivedTime,
      completedTime: this.ecall.completedTime,
      // status: Number(this.ecall.status),
      status: this.ecall.status,
      remarks: this.ecall.remarks,
      customerReport: this.ecall.customerReport,
      contactPerson: this.ecall.contactPerson,
      contactNumber: this.ecall.contactNumber,
      siteId: this.ecall.siteId,
      teamIds: this.ecall.teamIds,
      userAssignModels: this.technicianListModel,
      equipList: this.equipmentDetailListModel,
    };
  }

  editEcall(): void {
    this.ecallEditService
      .edit(this.ecall.id, this.editEcallInputs)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;

        }
      );
  }

  selectAll(event): void {
    this.equipmentList.forEach(equipment => {
      if (event.target.checked) {
        this.equipmentCheckboxes[equipment.equipmentId] = true;
        if (!this.selectedIds.includes(equipment.equipmentId)) {
          this.selectedIds.push(equipment.equipmentId);
        }
      } else {
        this.equipmentCheckboxes = {};
        this.selectedIds.length = 0;
      }
    });
  }

  closeSuccessModel() {
    this.router.navigate(['/home/e-call/detail/' + this.ecall.id]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/e-call']);
    } else {
      this.dangerModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-edit/ecall-edit.component.ts